import {
  PersonSimpleWalk, BellRinging, BellSlash, Phone, BatteryCharging,
  BatteryWarning, DoorOpen, WifiSlash, WifiHigh, Heartbeat, Pulse,
} from '@phosphor-icons/react';

// Single source of truth for event-type → icon, shared across Events,
// Dashboard, Patient/Room detail and the alert drawer.
const EVENT_ICON = {
  fall: PersonSimpleWalk,
  sos: BellRinging,
  button_press: BellRinging,
  sos_cancel: BellSlash,
  call: Phone,
  charging: BatteryCharging,
  low_battery: BatteryWarning,
  door_open: DoorOpen,
  door_close: DoorOpen,
  window_open: DoorOpen,
  window_close: DoorOpen,
  offline: WifiSlash,
  online: WifiHigh,
  heartbeat: Heartbeat,
  inactivity: Heartbeat,
};

export function eventIcon(type) {
  return EVENT_ICON[type] || Pulse;
}

// Pull a normalised call record out of an event's meta (EV-04/EV-05 call log).
export function callInfo(ev) {
  const c = ev?.meta?.call;
  if (!c) return null;
  return {
    number: c.number || '',
    answered: !!c.answered,
    durationS: c.duration_s ?? null,
    direction: c.direction || 'outgoing',
    at: c.at || ev.created_at,
  };
}
